<div id="mainPageLayout">
    <div class="navigationCol">
        <a routerLink="/dashboard" class="logo">My Event Pass</a>
        <app-mainnavigation></app-mainnavigation>
    </div>
    <div class="contentCol">
        <router-outlet></router-outlet>
    </div>
</div>
